import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, withLatestFrom } from 'rxjs';
import { catchError, exhaustMap, mergeMap, switchMap } from 'rxjs/operators';
import { ParameterType, SitesService, SitesView } from '../../_generated';
import { RequestStatusAction } from '../actionstypes/request-status/request-status.actiontype';
import * as SiteIdAction from '../actionstypes/selected-id/site-id.actiontype';
import { SitesRequestStatusAction } from '../actionstypes/sites/sites-request-status.actiontype';
import * as SitesAction from '../actionstypes/sites/sites.actiontype';
import { DataEntryStore } from '../reducers/data-entry.reducer';
import { getDataType } from '../selectors/data-type.selector';
import { getSelectedEntryCycle } from '../selectors/entry-cycles.selector';

@Injectable()
export class SitesEffect {
  private readonly actions$ = inject(Actions);
  private readonly sitesService = inject(SitesService);
  private readonly store = inject(Store<DataEntryStore>);

  loadSites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SitesAction.SitesAction.Load),
      exhaustMap(() => {
        return of(new RequestStatusAction(SitesRequestStatusAction.Load));
      }),
    ),
  );

  requestSites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SitesRequestStatusAction.Load),
      withLatestFrom(this.store.select(getDataType), this.store.select(getSelectedEntryCycle)),
      exhaustMap(([, dataType, selectedEntryCycle]: [SitesAction.Load, ParameterType, any]) => {
        return this.sitesService.sitesControllerFindAll(dataType, selectedEntryCycle?.id).pipe(
          switchMap((sites: SitesView[]) => [new SiteIdAction.Sync(sites.map((site) => site.id)), new SitesAction.Get(sites)]),
          catchError((error) => of(new RequestStatusAction(SitesRequestStatusAction.Error, error as Error))),
        );
      }),
    ),
  );

  successRequestSites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SitesAction.SitesAction.Get),
      mergeMap(() => of(new RequestStatusAction(SitesRequestStatusAction.Success))),
    ),
  );
}
